export default "/assets/images/dog-face.png?706e0b39aeb4ca37eede9b18e35aa08e";